<template>
  <b-modal @hide="createModalClose" ref="createBusinessFormModal" size="xl" :title="$t(type.name) + $t('カスタマイズ') + ' ' + $t('新規作成')">
    <div class="form-group row py-3">
      <label for="name" class="col-sm-4 col-form-label">
        {{ $t('帳票名称:') }}
      </label>
      <div class="col-sm-8">
        <input v-model="name" type="text" class="form-control" name="name" />
      </div>
    </div>
    <div class="form-group row">
      <label for="" class="col-sm-4 col-form-label">{{ $t('SVGファイル画像') }}</label>
      <div class="col-sm-8" ref="referenceSVG">
        <input class="form-file" type="file" name="imprint" ref="svgfile" @change="svgFile($event)" />
      </div>
      <div class="d-flex" style="margin: 2rem auto !important;">
        <template v-if="svgFileData.url || showSvgImage">
          <div class="form-img">
            <img :src="svgFileData.url ? svgFileData.url : showSvgImage" width="100%" style="border: solid 1px black;">
          </div>
          <span class="ml-3 form-file-delete">
            <font-awesome-icon
              :icon="['fas', 'times-circle']"
              class="text-danger"
              @click="deleteSvgFile"
            />
          </span>
        </template>
      </div>
    </div>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-between w-100">
        <q-btn rounded @click="createModalClose" :disabled="create.registration">
          <div class="row text-center no-wrap">
            <svg class="icon mr-4" viewBox="0 0 24 24">
              <use xlink:href="#x-mark-1" />
            </svg>
            <div>{{ $t('Cancel') }}</div>
          </div>
        </q-btn>
        <q-btn rounded color="success" @click="onRegister" :disabled="create.registration || !name || !type.type || !svg">
          <svg class="note-31 mr-4" viewBox="0 0 24 24">
              <use xlink:href="#note-31" />
            </svg>
          <div class="row text-center no-wrap">
            <div>{{ $t('Register') }}</div>
          </div>
        </q-btn>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

const templateFileType = {
  business_form: 'form',
}

export default {
  data() {
    return {
      name: '',
      type: {},
      companyId: null,
      create: {
        load: false,
        registration: false,
        error: '',
      },
      svgFileData: {
        url: '',
        data: '',
      },
      showSvgImage: '',
      isDeleteSvgFile: false,
      svg: '',
    }
  },
  methods: {
    async createModalOpen(item = {}) {
      this.type = item
      this.companyId = item.companyId
      this.$refs.createBusinessFormModal.show()
    },
    createModalClose() {
      this.type = {}
      this.name = ''
      this.deleteSvgFile()
      this.$refs.createBusinessFormModal.hide()
    },
    async onRegister() {
      const params = {
        name: this.name,
        type: this.type.type,
        isDefault: false,
        varsJson: {},
        drawJson: {},
        templateFile: {
          companyId: this.companyId,
          type: templateFileType.business_form,
          data: this.svg,
        },
      }
      await this.createRegister(params)
    },
    _createRegister(params) {
      return this.$axios({
        method: 'post',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/business_form`,
        data: params,
      })
    },
    async createRegister(params) {
      this.create.error = ''
      this.create.registration = true

      try {
        await this._createRegister(params)

        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.create = {
          load: false,
          registration: false,
          error: '',
        }
        this.$refs.createBusinessFormModal.hide()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.create.registration = false
    },
    async svgFile(event) {
      const file = event.target.files[0]
      if (!/\.svg$/i.test(file.name)) {
        this.$toasted.show(this.$t('ファイルの形式が異なります'))
        this.deleteSvgFile()
        return
      }
      this.isDeleteSvgFile = false
      this.svgFileData.data = file
      this.svgFileData.url = window.URL.createObjectURL(file)
      await this.$axios({
        method: 'get',
        url: this.svgFileData.url,
      }).then(data => {
        this.svg = data.data
      })
    },
    deleteSvgFile() {
      this.isDeleteSvgFile = true
      this.showSvgImage = ''
      this.$refs.svgfile.value = ''
      this.svgFileData = {
        url: '',
        data: '',
      }
      this.svg = ''
    },
  },
  watch: {
    //
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .q-btn__content.col, .row {
    margin: 0 !important;
  }
  .note-31 {
    width: 21px;
    height: 21px;
    fill: white !important;
  }
  .icon {
    width: 21px;
    height: 21px;
  }
}
</style>
